var _excluded = ["children", "className", "component"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import Transition from 'react-transition-group/Transition';
import '../../css/shared/animated_height.css';
import mergeRefs from 'react-merge-refs';
import { jsx as ___EmotionJSX } from "@emotion/react";
var AnimatedHeight = /*#__PURE__*/React.forwardRef((_ref, ref) => {
  var {
      children,
      className,
      component: Component = 'div'
    } = _ref,
    transitionProps = _objectWithoutProperties(_ref, _excluded);
  var nodeRef = React.useRef(null);
  var setHeight = React.useCallback(height => {
    if (nodeRef.current) {
      nodeRef.current.style.height = height;
      // eslint-disable-next-line @typescript-eslint/no-unused-expressions
      window.getComputedStyle(nodeRef.current).height;
    }
  }, []);
  var animatedRef = React.useRef(null);
  var onExitOrEnter = React.useCallback(() => {
    var _animatedRef$current;
    return setHeight("".concat((_animatedRef$current = animatedRef.current) === null || _animatedRef$current === void 0 ? void 0 : _animatedRef$current.getBoundingClientRect().height, "px"));
  }, [setHeight]);
  var onEntered = React.useCallback(() => setHeight('auto'), [setHeight]);
  var onExiting = React.useCallback(() => setHeight(''), [setHeight]);
  var endListener = React.useCallback(done => {
    if (nodeRef.current) {
      nodeRef.current.addEventListener('transitionend', done, false);
    }
  }, []);
  return ___EmotionJSX(Transition, _extends({
    nodeRef: nodeRef
  }, transitionProps, {
    addEndListener: endListener,
    onEnter: onExitOrEnter,
    onEntered: onEntered,
    onExit: onExitOrEnter,
    onExiting: onExiting
  }), state => {
    var containerClassName = classNames({
      'vn-animated-height__container': true,
      ["vn-animated-height__container--".concat(state)]: ['entering', 'entered', 'exiting'].includes(state)
    }, className);
    return ___EmotionJSX("div", {
      className: containerClassName,
      ref: nodeRef
    }, ___EmotionJSX("div", {
      className: "vn-animated-height__wrapper",
      ref: mergeRefs([ref, animatedRef])
    }, ___EmotionJSX(Component, {
      className: "vn-animated-height__wrapper-inner"
    }, children)));
  });
});
AnimatedHeight.propTypes = {
  className: PropTypes.string,
  component: PropTypes.string,
  in: PropTypes.bool
};
export default AnimatedHeight;